// extracted by mini-css-extract-plugin
export default {"root":"HeaderLeft_root__2BKCd","search":"HeaderLeft_search__iI7kt"};